/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, } from 'react'

const TimerComponent = (props) => {
    const { timerRunning, LogMeOut, timerReset, setTimerReset, setTimerRunning,Logged ,setTimerAlert,setTimePeriodOver} = props
    // Timer state
    // const [hour, setHour] = useState('');
    const [timeLeft, setTimeLeft] = useState({ hours: '', minute: '', seconds: '' });
    const [duration, setDuration] = useState(() => {
    // Try to get the initial duration from localStorage
    const storedDuration = sessionStorage.getItem('timerDuration');
    return storedDuration ? parseInt(storedDuration, 10) : 14000; // Default: 14000 seconds (10 minutes)
  });

    //Use effect to run timer for completing application
    useEffect(() => {
        // To start the timer for auto log-off
        const setTimer = (durationInSeconds) => {
            // const durationInSeconds = 3600
            if (durationInSeconds === 20) {
                setTimePeriodOver(true)
                setTimerAlert(true)
            }
            if (durationInSeconds <= 0) {
                LogMeOut()
                return null
            } else {
                let hours = Math.floor(durationInSeconds / (60 * 60))
                let divisor_for_minutes = durationInSeconds % (60 * 60);
                let minutes = Math.floor(divisor_for_minutes / 60);

                let divisor_for_seconds = divisor_for_minutes % 60;
                let second = Math.ceil(divisor_for_seconds);
                let obj = {
                    "hours": hours,
                    "minute": minutes,
                    "seconds": second
                };
                return obj;
            }
        }
        if (timerReset === true) {
            setDuration(14000)
            setTimerRunning(false)
            setTimerReset(false)
        } else if (timerRunning === true) {
            const timer = setInterval(() => {
                // Get the timestamp when the timer started or was reset
        const startTime = parseInt(sessionStorage.getItem('timerStartTime'), 10) || Date.now();
        // Calculate the time elapsed since the timer started or was reset
        const timeElapsed = Math.floor((Date.now() - startTime) / 1000);
        let timeObj = setTimer(duration - timeElapsed);
        setTimeLeft(timeObj);
        setDuration(duration - timeElapsed);
            }, 1000);
            // clearing interval
            return () =>{
        clearInterval(timer);
        // Store the current duration and the timestamp when the timer was stopped
        sessionStorage.setItem('timerDuration', duration.toString());
        sessionStorage.setItem('timerStartTime', Date.now().toString());
            } 
        }
    }, [duration, timerRunning, timerReset,LogMeOut]);

    return (
        timerReset === false && duration <= 600 && Logged && timeLeft &&
        < div className='timer-display' >
            <span className='timer-display-text'>Remaining Time :  </span>
            <span className='timer-wrap'>{timeLeft.minute + ' m : ' +timeLeft.seconds + ' s '}</span>

        </div >

    );

};

export default TimerComponent